import React from 'react'
import styles from './LeadQualityScreen.module.css'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import LeadCircularProgressComponent from './LeadCircularProgressComponent';
import NotAvaliableDataImage from '../../Assets/Images/not-avaliable.svg'


interface LeadQualityCardComponentProps {
    leadQualityTitle: any,
    leadQualityScoreType: any,
    leadQualityScore: any,
    displayReport: any
}

const LeadQualityCardComponent: React.FC<LeadQualityCardComponentProps> = ({ leadQualityTitle, leadQualityScoreType, leadQualityScore, displayReport }) => {
    return (
        <div className={`${styles.LqsCard} ${displayReport === "Y" ? styles[leadQualityScoreType] : styles.poor}`}>
            <div className={styles.LqsCardLeft}>
                <div className={styles.LqsCardTitle}>{leadQualityTitle}</div>
                {
                    displayReport === "Y" ? 
                    <div className={`${styles.LqsCardScore} ${styles[leadQualityScoreType]}`}>{leadQualityScoreType} <ArrowForwardIosOutlinedIcon className={styles.LqsCardArrow} /></div>
                    :
                    <div className={`${styles.LqsCardScore} ${styles.poor}`}>Not Available</div>
                }
            </div>
            <div className={styles.LqsCardRight}>
                {displayReport === "Y" ? <LeadCircularProgressComponent value={leadQualityScore} leadQualityScoreType={leadQualityScoreType} /> : <img src={NotAvaliableDataImage} alt='no-image' width={"100%"} />}
            </div>
        </div>
    )
}

export default LeadQualityCardComponent